const translations = {
  fr: {
    dashboard: {
      reachCume: 'Portée (Cume)',
      dashboard: 'Tableau de bord',
      listening: 'Écoute',
      weeklyListeningTime: 'Écoute moy. hebdo.',
      cumulativeListeningTime: 'Écoute cumulative',
      listeningTimePerPerson: 'Écoute par auditeur',
      weeklyListeningTimePerPerson: 'Écoute moy. hebdo. par auditeur',
      cumulativeListeningTimePerPerson: 'Écoute cumulative par auditeur',
      weeklyReach: 'Portée moy. hebdo. (Cume)',
      cumulativeReach: 'Portée cumulative (Cume)',
      listeningInHours: 'Écoute (heures)',
      dashboardError: 'Le tableau de bord ne peut être affiché',
      hours: 'Heures',
      metricsAreAFallback: 'Des données antérieures sont présentement affichées.',
      ifProblemPersistsContactUs: 'Veuillez nous contacter si le problème persiste.',
      demography: 'Démographie',
      ages: 'Âges',
      gender: 'Genre',
      lessOld: 'A25-54',
      old: 'A35+',
      geolocalisation: 'Géolocalisation',
      lastDays: 'derniers jours',
      previousDays: 'jours précédents',
      mondayToFriday: 'Lundi au vendredi',
      audienceComparative: "Comparatif d'audience",
      byRegion: 'Par régions',
      byAntennas: 'Par antennes',
      insideAntennaReach: "Portée de l'antenne",
      betaFeature: '*Cette fonctionnalité est en beta',
    },
  },
  en: {
    dashboard: {
      reachCume: 'Reach (Cume)',
      dashboard: 'Dashboard',
      listening: 'Listening',
      weeklyListeningTime: 'Average Weekly Listening Time',
      cumulativeListeningTime: 'Cumulative Listening Time',
      listeningTimePerPerson: 'Listening time per person (TSL)',
      weeklyListeningTimePerPerson: 'Average Weekly Listening time per person (TSL)',
      cumulativeListeningTimePerPerson: 'Cumulative Listening Time per person (TSL)',
      weeklyReach: 'Average Weekly Reach (Cume)',
      cumulativeReach: 'Cumulative Reach (Cume)',
      listeningInHours: 'Listening (hours)',
      dashboardError: 'The dashboard could not be fetched',
      hours: 'Hours',
      metricsAreAFallback: 'Past metrics are currently displayed.',
      ifProblemPersistsContactUs: 'Please contact us if this problem persists.',
      demography: 'Demography',
      ages: 'Ages',
      gender: 'Gender',
      lessOld: 'A25-54',
      old: 'A35+',
      geolocalisation: 'Localisation',
      lastDays: 'last days',
      previousDays: 'previous days',
      mondayToFriday: 'Monday to friday',
      audienceComparative: 'Audience comparative',
      byRegion: 'By regions',
      byAntennas: 'By antennas',
      insideAntennaReach: 'Antenna reach',
      betaFeature: '*This feature is in beta',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/i18n/dashboard.js